import axios from 'axios';
import ROUTES from '../api/routes';
import { TOKEN_CLIENT_LOCAL_STORAGE_NAME } from '../constants/constants';

export default function getTaskManagerSavingsOverall(year) {
  return (_, getStore) => {
    const { accessToken } = JSON.parse(localStorage.getItem(TOKEN_CLIENT_LOCAL_STORAGE_NAME)) || {};
    const { organizationId } = getStore().data;

    const params = {
      compareAgainst: year,
    };

    return axios.get(
      `${ROUTES.GET_BUILDINGS}/${organizationId}/savings/overall/`,
      {
        headers: {
          accept: 'application/json',
          Authorization: accessToken,
        },
        params,
      },
    )
      .then(({ data }) => data)
      .catch((err) => err);
  };
}
